import { Button, Css, px, useTestIds } from "@homebound/beam";
import { getStage } from "src/context";
import { useCurrentInternalUserQuery, useStopInternalUserImpersonationMutation } from "src/queries/user.generated";
import { isStableQaEnvironment } from "src/utils";
import { topNavHeight } from "./global-nav/GlobalNav";

const bannerHeight = 48;

type ImpersonationWarningProps = { stickyTopPx?: number };

export function ImpersonationWarning(props: ImpersonationWarningProps) {
  const { data } = useCurrentInternalUserQuery();
  const currentInternalUser = data?.currentInternalUser;
  const { stickyTopPx = topNavHeight } = props;
  const testId = useTestIds({}, "impersonationWarning");
  const [stopImpersonation] = useStopInternalUserImpersonationMutation();

  async function handleStopImpersonation() {
    await stopImpersonation();
    window.location.reload();
  }

  return (
    <div
      css={Css.bgOrange200.fs0.w100.sticky.z999.h(px(bannerHeight)).df.aic.jcc.gap2.$}
      style={{ top: px(stickyTopPx) }}
      {...testId}
    >
      <div>
        You are impersonating{" "}
        <strong>
          {currentInternalUser?.name} ({currentInternalUser?.email})
        </strong>
        . Changes will be made as this user.
      </div>
      <div {...testId.stopImpersonation}>
        <Button label="Stop impersonating" variant="tertiary" onClick={handleStopImpersonation} />
      </div>
    </div>
  );
}

/** Sticky offset for the impersonation banner when rendered below other environment warnings. */
export function impersonationWarningStickyTopPx() {
  const stage = getStage();
  const qaBannerOffset = stage === "qa" && !isStableQaEnvironment() ? bannerHeight : 0;
  return topNavHeight + qaBannerOffset;
}
